import React from "react";
import { CheckCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Design tokens
const colors = {
  primary: "hsl(var(--primary))",
  charcoal: "hsl(var(--foreground))",
  midGray: "hsl(var(--muted-foreground))",
  success: "#10b981",
};

interface ThankYouModalProps {
  isOpen: boolean;
  onClose: () => void;
  email?: string;
}

export const ThankYouModal: React.FC<ThankYouModalProps> = ({
  isOpen,
  onClose,
  email,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[440px] p-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-2 text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center"
              style={{ backgroundColor: `${colors.success}15` }}
            >
              <CheckCircle
                className="w-10 h-10"
                style={{ color: colors.success }}
              />
            </div>
          </div>

          <DialogTitle
            className="text-2xl font-semibold"
            style={{ color: colors.charcoal }}
          >
            Thank You for Your Interest!
          </DialogTitle>

          <DialogDescription
            className="text-sm leading-relaxed mt-2"
            style={{ color: colors.midGray }}
          >
            We've received your application to join the TerraMatrix Pilot Program.
          </DialogDescription>
        </DialogHeader>

        <div className="px-6 pb-6 space-y-4">
          {/* Next Steps */}
          <div
            className="bg-gray-50 rounded-lg p-4 text-sm"
            style={{ color: colors.charcoal }}
          >
            <p className="font-medium mb-2">What happens next?</p>
            <ul className="list-disc list-inside space-y-1" style={{ color: colors.midGray }}>
              <li>Our team will review your application within 5-7 business days</li>
              <li>
                We'll reach out to you at{" "}
                <span className="font-medium" style={{ color: colors.charcoal }}>
                  {email || "your email"}
                </span>{" "}
                with next steps
              </li>
              <li>Selected partners will receive early access to TerraMatrix</li>
            </ul>
          </div>

          {/* Call to Action */}
          <Button
            onClick={onClose}
            className="w-full h-10 font-medium transition-all duration-200 hover:brightness-95"
            style={{
              backgroundColor: colors.primary,
              color: "#FFFFFF",
            }}
          >
            Back to Home
          </Button>

          {/* Additional Info */}
          <p className="text-xs text-center" style={{ color: colors.midGray }}>
            Have questions? Reach out to{" "}
            <a
              href="mailto:pilot@terramatrix.io"
              className="hover:underline"
              style={{ color: colors.primary }}
            >
              pilot@terramatrix.io
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
